<div [class]="'option-popover-container d-flex flex-column gap-2 ' + customClass" (click)="onHandleParent($event)">
  <!-- The container for the entire popover, with dynamic classes and a click handler -->
  @if (label) {
    <h6 class="menu-title">{{ label }}</h6>
  }
  <!-- The title of the menu, bound to the 'label' property -->

  @if (isSearchable) {
    <!-- Conditionally render the search input if 'isSearchable' is true -->
    <div class="search-input-container">
      <input type="text" class="search-input" autofocus placeholder="Search..." (keydown)="onSearchKeyDown($event)" #searchInput (keydown.enter)="onEnter()" [(ngModel)]="searchText" />
    </div>
  }

  <div class="mat-option-menu-container">
    <!-- Container for the options in the menu -->
    @for (item of optionList | filter: searchText : "Name"; track $index) {
      <!-- Loop through 'optionList', filtering by 'searchText' on the 'Name' property, and tracking by index -->
      <div class="menu-option d-flex align-items-center gap-2 {{ $index }}" [attr.data-id]="item.ID" (keydown)="onOptionKeyDown($event)" [tabIndex]="$index" (click)="onSelectOption(item)">
        @if (isShowArrows) {
          <!-- Conditionally show an arrow icon if 'isShowArrows' is true -->
          <mat-icon class="fs-20 menu-option-icon" [ngClass]="{ 'text-primary': item.isSelected, 'text-dark-gray-3': !item.isSelected }">done</mat-icon>
        }

        @if (item.InnerHtml) {
          <!-- Conditionally render an innerHTML if 'item.innerHTML' exists -->
          <!-- <div [innerHTML]="item.InnerHtml | sanitizer :'html'"></div> -->
        }

        @if (item.Image) {
          <!-- Conditionally render an image if 'item.Image' exists -->
          <img [src]="item.Image" onerror="this.src = 'global-assets/user-profile.png'" alt="logo" class="menu-option-logo" />
        }
        <div>
          <!-- Container for the option's text and count -->
          <span class="menu-copy">{{ item.Name }} </span>
          <!-- Display the name of the option -->
          @if (item?.iCount) {
            <span class="menu-count">{{ item?.iCount }}</span>
          }
          <!-- Display the count associated with the option (if available) -->
        </div>
      </div>
    } @empty {
      <!-- If 'optionList' is empty, display this fallback -->
      <div class="menu-option d-flex align-items-center gap-2">
        <span class="menu-copy">{{ notFoundText }}</span>
        <!-- Display a message indicating no options were found, bound to 'notFoundText' -->
      </div>
    }
  </div>
</div>
